import axios from "axios";
import { ref, computed } from "vue";
import { defineStore } from "pinia";
import { useRouter } from "vue-router";
import { useModals } from "@/utils/useModals";
import { useFieldsStore } from "./storeFieldData";
import { useSettingsStore } from "./storeSettings";
import { phoneFormatter } from "@/utils/functions";
import { API_URL } from "@/utils/constans";
import { QUIZ_LITE_ID } from "@/utils/constans";

export const useQuestionnairesStore = defineStore("questionnaires", () => {
	const router = useRouter();
	const storeField = useFieldsStore();
	const storeSettings = useSettingsStore();
	const { closeModal, openModal } = useModals();

	const token = ref(localStorage.getItem("token"));
	const setToken = (newToken) => {
		token.value = newToken;
		localStorage.setItem("token", newToken);
	};

	const removeToken = () => {
		token.value = null;
		localStorage.removeItem("token");
	};

	const QUIZ_LITE = QUIZ_LITE_ID;
	const loaderBtn = ref(false);
	const userData = ref({});
	const responseError = ref("");
	const responseErrorFile = ref("");
	const textErrorNumberNotFound = ref("");
	const isShowScreenEnd = ref(false);

	const questionnaireType = computed(() => userData.value?.questionnaire_type?.replace(/_/g, '-') || '');
	// const questionnaireType = computed(() => 'cash-prize');

	const updateQuestionnaire = (showScreen) => {
		storeField.updateBtnsTitles(["firstName", "lastName", "patronymic", "email","phone","agreement","bik","accountNumber","birthDate","series","number","issuedBy","issueDate","departmentCode","inn","zipCode","street","house"]);
		storeField.updateFiles();
		responseError.value = "";
		isShowScreenEnd.value = showScreen;
	}

	axios.interceptors.response.use(
		(response) => response,
		(error) => {
			if (error.response && error.response.status === 401) {
				removeToken();
				delete axios.defaults.headers.common["Authorization"];
			}
			return Promise.reject(error);
		}
	);

	const setAuthHeader = () => {
		const urlParams = new URLSearchParams(window.location.search);
		const tokenURL = urlParams.get("token");
		if (tokenURL) {
			token.value = tokenURL;
		} else {
			token.value = localStorage.getItem("token");
		}
		if (token.value) {
			axios.defaults.headers.common["Authorization"] = `Bearer ${token.value}`;
		} else {
			delete axios.defaults.headers.common["Authorization"];
		}
	};

	const registration = async () => {
		loaderBtn.value = true;
		const registrationParams = localStorage.getItem("registration_params") || "";

		try {
			const formData = new FormData();

			formData.append("first_name", storeField.fields.firstName.title);
			formData.append("last_name", storeField.fields.lastName.title);
			formData.append("phone_number", storeField.fields.phone.title);
			formData.append("email", storeField.fields.email.title);
			formData.append("password", storeField.fields.passwordRepeat.title);
			formData.append("registration_params", registrationParams);
			formData.append("is_policy", storeField.fields.agreement.title);
			formData.append("is_rules", storeField.fields.rules.title);
			formData.append("agree_to_advertising", storeField.fields.agreeToAdvertising.title);

			const res = await axios.post(`${API_URL}/api/users/registration`, formData, {
				headers: {
					"Content-Type": "multipart/form-data",
				},
			});

			openModal("registrationEnd");
			// sendMetrik("reachGoal", "registration_succes");
			storeField.updateRegestrationBtn();
		} catch (error) {
			console.error("Error sendRegistration", error);
			responseError.value = error.response?.data?.detail || "Ошибка при отправке данных.";
			console.log("error.response:", error.response);
		} finally {
			loaderBtn.value = false;
		}
	};

	const authorization = async () => {
		loaderBtn.value = true;
		const parameters = {
			email: storeField.fields.email.title,
			password: storeField.fields.password.title,
		};

		try {
			const res = await axios.post(`${API_URL}/api/users/authorization`, parameters);
			setToken(res.data.access);
			setAuthHeader();
			await userInfo();
			closeModal();
			// sendMetrik("reachGoal", "authorization_succes");
			storeField.updateFields("email", "disabledBtn", false);
			storeField.updateFields("password", "disabledBtn", false);
		} catch (error) {
			console.log("error sendAuthorization:", error);
			responseError.value = error.response?.data?.detail || "Ошибка при отправке данных.";
			if (error.response.status === 557) {
				openModal("notVerified");
			}
		} finally {
			loaderBtn.value = false;
		}
	};

	const userInfo = async () => {
		try {
			setAuthHeader();
			const res = await axios.get(`${API_URL}/api/users/me`);
			userData.value = res.data;
			initWidget();
		} catch (error) {
			if (error.response && error.response.status === 401) {
				console.warn("Пользователь не авторизован");
				userData.value = null;
			} else {
				console.error("Error getUserInfo", error);
				throw error;
			}
		}
	};

	const checkingAvitoUser = async () => {
		loaderBtn.value = true;
		try {	
			const parameters = {
				phone_number:  phoneFormatter(storeField.fields.phone.title),
				quiz_lite: QUIZ_LITE
			}		
			const response = await axios.post(`${API_URL}/api/questionnaire/check-phone-number`, parameters);
			userData.value = response.data;
			console.log("🚀 ~ checkingAvitoUser ~ userData.value:", userData.value)
			storeField.updateBtnsTitles(["phone", "agreement"]);
			responseError.value = "";
		} catch (error) {
			console.log("error checkingAvitoUser:", error);
			responseError.value = error.response?.data?.detail || "Ошибка при отправке данных, проверьте введенные данные.";
		} finally {
			loaderBtn.value = false;
		}
	};

	const sendQuestionnaire = async () => {
		loaderBtn.value = true;
		
		try {
			if(questionnaireType.value === "tax-free-cash-prize") {
				
				const parameters = {
					quiz_lite: QUIZ_LITE,
					user: userData.value.user_id,
					first_name: storeField.fields.firstName.title,
					last_name: storeField.fields.lastName.title,
					middle_name: storeField.fields.patronymic.title,
					phone_number:  phoneFormatter(storeField.fields.phone.title),
					email: storeField.fields.email.title,
					bic: storeField.fields.bik.title,
					account_number: storeField.fields.accountNumber.title,
					inn: storeField.fields.inn.title
				}
				await axios.post(`${API_URL}/api/questionnaire/tax-free-cash-prize`, parameters)
				updateQuestionnaire(true);
			} else {
				
				const formData = new FormData();

				if (storeField.fields.filesForPost && storeField.fields.filesForPost.length > 0) {
					for (const file of storeField.fields.filesForPost) {
						formData.append("photos", file);
					}
				}
				
				formData.append("quiz_lite", QUIZ_LITE);
				formData.append("user", userData.value.user_id);
				formData.append("first_name", storeField.fields.firstName.title);
				formData.append("last_name", storeField.fields.lastName.title);
				formData.append("middle_name", storeField.fields.patronymic.title);
				formData.append("phone_number", phoneFormatter(storeField.fields.phone.title));
				formData.append("email", storeField.fields.email.title);

				if ( questionnaireType.value === 'cash-prize') {					
					formData.append("bic", storeField.fields.bik.title);
					formData.append("account_number", storeField.fields.accountNumber.title);
				}

				if (questionnaireType.value === 'cash-prize' || questionnaireType.value === 'physical-prize') {
					formData.append("birth_date", storeField.fields.birthDate.title);
					formData.append("series", storeField.fields.series.title);
					formData.append("number", storeField.fields.number.title);
					formData.append("issued_by", storeField.fields.issuedBy.title);
					formData.append("issue_date", storeField.fields.issueDate.title);
					formData.append("department_code", storeField.fields.departmentCode.title);
					formData.append("inn", storeField.fields.inn.title);
				}

				if (questionnaireType.value === 'physical-prize' || questionnaireType.value === 'tax-free-physical-prize') {
					formData.append("zip_code", storeField.fields.zipCode.title);
					formData.append("city", storeField.fields.city.title);
					formData.append("street", storeField.fields.street.title);
					formData.append("house", storeField.fields.house.title);
					formData.append("apartment", storeField.fields.apartment.title);
				}

	
				await axios.post(`${API_URL}/api/questionnaire/${questionnaireType.value}`, formData, {
					headers: {
						"Content-Type": "multipart/form-data",
					},
				});
				updateQuestionnaire(true)
			}
		} catch (error) {
			console.log("error taxFreeCashPrize:", error);
			responseError.value = error.response?.data?.detail || "Ошибка при отправке данных.";
			responseErrorFile.value = `${error.response?.data?.photos[0]} Добавьте файлы.` || '';
		} finally {
			loaderBtn.value = false;
		}
	};		

	return {
		setAuthHeader,
		registration,
		authorization,
		userInfo,
		checkingAvitoUser,
		sendQuestionnaire,
		updateQuestionnaire,
		
		userData,
		loaderBtn,
		textErrorNumberNotFound,
		responseError,
		questionnaireType,
		isShowScreenEnd,
		responseErrorFile	
	};
});
